import React, { Component } from 'react';
import { IonBadge, IonHeader, IonButton, IonButtons, IonToolbar,
  IonSelectOption, IonContent, IonList, IonItem, IonSelect,
} from '@ionic/react';
import states from '../jsons/states.json';

type Props = {
  filteredStates: string[];
  allTags: string[];
  dismissModal: () => void;
  updateStateFilters: (trackList: string[]) => void;
}

type State = {
  stateFilters: string[];
  selected: string[],
}

export default class PlaceListFilter extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      ...this.state,
      selected: props.filteredStates,
      stateFilters: props.filteredStates,
    }
  }

  componentDidMount() {
    console.log(this.state)
  }
  stateSelected = (e: CustomEvent) => {
    this.setState({
      ...this.state,
      selected: e.detail.value,
    });
    
  }

  resetFilters = () => {
    this.props.updateStateFilters([]);
    this.setState({
      ...this.state,
      selected: [],
    });
    this.props.dismissModal();
  }

  applyFilters = () => {
    this.props.updateStateFilters(this.state.selected);
    this.props.dismissModal();
  }

  render() {
    const isAnySelected = this.state.selected.length > 0;
    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={this.props.dismissModal}>Cancel</IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton onClick={this.applyFilters} strong>Save</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent class="outer-content">
          <IonList>
            <IonSelect
              onIonChange={this.stateSelected}
              value={this.state.selected}
              selectedText="Select State(s)"
              placeholder="Select State(s)"
              multiple={true}
              cancelText="Cancel"
              okText="Confirm">
            { Object.keys(states).map((key: string, index: number) => (
              <IonSelectOption key={key} value={key}>{states[key]} ({key})</IonSelectOption>
            ))}
            </IonSelect>
            <IonItem style={ isAnySelected ? {} : {display: 'none'} }>
              <div>
              { this.state.selected.map((item: any, index: number) => (
                <IonBadge key={`badge${item}`} style={{'margin': '5px'}} color="medium"> {states[item]} </IonBadge>
              ))}
              </div>
            </IonItem>
          </IonList>
          <IonList>
            <IonItem onClick={this.resetFilters} detail={false} class="reset-filters">
              <IonButton>Reset</IonButton>
            </IonItem>
          </IonList>
        </IonContent>
      </>
    );
  }
}
